import axiosClient from "./axiosClient";

export const regionAndTownshipApi = {
    getRegions: () => {
        const url = "/region/get";
        return axiosClient.get(url);
    },

    getTownships: (region_id: string) => {
        const url = `/region/state/get?regionId=${region_id}`;
        return axiosClient.get(url);
      },
};